module.exports = __webpack_public_path__ + "static/media/support3.baceb745.webp";